module.exports = __webpack_public_path__ + "img/edit.3639be89.svg";